import { CHALLENGE_TEMPLATES, CHALLENGE_METRIC_LABEL_KEYS, DIFFICULTY_COLORS, DIFFICULTY_LABEL_KEYS } from "../constants";
import type { ChallengeTemplate } from "../types";
import { useLocale } from "../../../context/LanguageContext";

interface ChallengeTemplatesProps {
  onSelect: (template: ChallengeTemplate) => void;
}

export function ChallengeTemplates({ onSelect }: ChallengeTemplatesProps) {
  const { t } = useLocale();
  return (
    <div>
      <h3 className="mb-2 text-sm font-medium text-muted-foreground">
        {t("challenges.startFromTemplate")}
      </h3>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
        {CHALLENGE_TEMPLATES.map((template) => (
          <button
            key={template.id}
            type="button"
            onClick={() => onSelect(template)}
            className="group flex items-center gap-2 rounded-lg border border-border bg-card px-3 py-2 text-left transition-all hover:border-primary/50 hover:shadow-sm"
          >
            <span className="text-xl">{template.emoji}</span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-1.5">
                <span className="truncate text-xs font-medium text-foreground group-hover:text-primary">
                  {template.name}
                </span>
                <span
                  className={`inline-block h-1.5 w-1.5 shrink-0 rounded-full ${DIFFICULTY_COLORS[template.difficulty]}`}
                  title={t(DIFFICULTY_LABEL_KEYS[template.difficulty])}
                />
              </div>
              <div className="truncate text-[10px] text-muted-foreground">
                {template.tagline}
              </div>
              <div className="mt-0.5 flex items-center gap-1">
                <span className="rounded bg-muted px-1 py-0.5 text-[9px] font-medium text-muted-foreground">
                  {t(CHALLENGE_METRIC_LABEL_KEYS[template.metric])}
                </span>
                <span className="rounded bg-muted px-1 py-0.5 text-[9px] font-medium text-muted-foreground">
                  {template.durationDays}{t("shared.recurrenceUnitShort.DAYS")}
                </span>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
